import ApiModel from "@/deprecated/models/api_client"

class UserModel extends ApiModel {
  constructor(attributes = {}) {
    super("/v2/account", attributes)
    this.id = attributes.id
  }

  // We add the api_key at the end of each call to the public API to authenticate user
  url() {
    return "/v2/account" + `?api_key=${gon.api_key}`
  }

  save(attributes = null, options = {}) {
    if (attributes) {
      this.set(attributes)
    }

    const url = this.url()
    const method = "PUT"

    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.getAttribute("content"),
    }

    return fetch(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(this.attributes),
    })
      .then((response) => {
        if (response.ok) {
          if (options.success) {
            options.success(this, response)
          }
          return response
        } else {
          throw new Error("Request failed")
        }
      })
      .catch((error) => {
        if (options.error) {
          options.error(this, error)
        }
        throw error
      })
  }
}

document.addEventListener("turbo:load", () => {
  if (typeof gon !== "undefined") {
    App.user = new UserModel(gon.user)
  }
})
